module.exports = __webpack_public_path__ + "static/the-wonderful-story-of-henry-sugar-and-six-more-e51cb3adf49c4b80a38bd42d31c01661.jpg";